import { getThemeColor, useTheme, VideoSingleStar } from '@sparemin/blockhead';
import cn from 'classnames';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { isFreeSelector } from 'redux/modules/pricing';
import bem from 'utils/bem';
import ProjectButton from '../../containers/ProjectButton';
import { INewProjectButtonProps } from './types';

const block = bem('video-transcription-button');

const VideoTranscriptionButton: React.SFC<INewProjectButtonProps> = ({
  className,
  description = 'Caption and clip full-length videos—perfect for YouTube and social media',
  icon,
  title,
  ...rest
}) => {
  const isFree = useSelector(isFreeSelector);

  const theme = useTheme();

  return (
    <ProjectButton
      className={cn(block(), className)}
      icon={
        <VideoSingleStar
          width="80px"
          height="40px"
          color={getThemeColor('s5')({ theme })}
        />
      }
      projectType="video-transcript"
      title="Video podcasting"
      description={description}
      ribbon={isFree ? 'Free * Limited time * Free' : undefined}
      to={{
        pathname: '/wizard',
        query: {
          type: 'video-transcription',
        },
      }}
      {...rest}
    />
  );
};

export default VideoTranscriptionButton;
